import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Table, Tabs } from "antd";
import { ColorfulTag } from "components";
import { CardChart } from "components";
import { PieChart, Pie, Legend, Cell } from "recharts";
import { colors } from "utils/config";
import { dateFormat, sortDates, sortStrings, withNumberingColumn } from "utils/utils";
import dayjs from "dayjs";

const TeacherTrials = () => {
  const teacherTrials = useSelector((state) =>
    state?.teachersProfile?.teacherTrials.filter((trial) => trial.status !== "In Process")
  );
  const schoolId = useSelector((state) => state?.user?.selectedSchool?.id);

  const teacherTrialsMapped = teacherTrials.map((trial, index) => {
    return {
      order: index,
      prospectId: trial.prospectId,
      student: trial.student,
      date: trial.date,
      status: trial.status,
      room: trial.room,
      key: index,
    };
  });

  const teacherTrialsMappedArchived = teacherTrialsMapped.filter((i) => i?.status?.includes("Archived"));
  //added an extra filter to exclude trials from active prospects
  const teacherTrialsMappedActive = teacherTrialsMapped.filter(
    (i) => !i?.status?.includes("Archived") && !i.status?.includes("Trial")
  );

  const pieDataActive = [];
  const statusDataActive = [];
  const pieDataFormer = [];
  const statusDataFormer = [];
  teacherTrialsMapped &&
    teacherTrialsMapped.reduce(function (res, value) {
      if (!res[value.status]) {
        res[value.status] = { name: value.status, value: 0 };
        if (!value?.status?.includes("Archived")) {
          pieDataActive.push(res[value.status]);
          statusDataActive.push(res[value.status]);
        }
        if (value?.status?.includes("Archived")) {
          pieDataFormer.push(res[value.status]);
          statusDataFormer.push(res[value.status]);
        }
      }
      res[value.status].value++;

      return res;
    }, {});

  const teacherTrialsCol = [
    {
      title: "Student",
      dataIndex: "student",
      key: "student",
      sorter: (a, b) => sortStrings(a, b, "student"),
      render: (student, { prospectId }) => {
        return <Link to={`/dashboard/${schoolId}/prospectProfile/${prospectId}`}>{`${student} `}</Link>;
      },
    },
    {
      title: "Prospect Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => sortStrings(a, b, "status"),
      render: (status) => (
        <p>
          <ColorfulTag text={status} />
        </p>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => sortDates(a, b, "date"),
      render: (date) => {
        return dayjs(date).format(dateFormat);
      },
    },

    {
      title: "Room",
      dataIndex: "room",
      key: "room",
      sorter: (a, b) => sortStrings(a, b, "room"),
      render: (room) => <p>{room}</p>,
    },
  ];
  return (
    <>
      <Tabs
        className={"teacherTabs"}
        defaultActiveKey="1"
        type={"card"}
        items={[
          {
            key: "1",
            label: "Active",
            children: (
              <Table
                rowKey="key"
                columns={withNumberingColumn(teacherTrialsCol)}
                dataSource={teacherTrialsMappedActive}
                pagination={false}
              />
            ),
          },
          {
            key: "2",
            label: "Former",
            children: (
              <Table
                rowKey="key"
                columns={withNumberingColumn(teacherTrialsCol)}
                dataSource={teacherTrialsMappedArchived}
                pagination={false}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default TeacherTrials;
